module.exports = __webpack_public_path__ + "img/nc-coop-logo.3a1232f0.jpg";